module.exports = __webpack_public_path__ + "img/wa.f7824c6c.png";